import { ExDialog } from '@boomi/exosphere';
import translations from '../../translations';
import { isNullOrUndefined, isNullOrWhitespace } from '../../utils/guard';
import { stringReplace } from '../../utils/string';
import { useEffect, useState } from 'react';
import { getMinutesFromDate } from './utils';
import { getSSOMetadata, signOutUser } from '../../utils/auth';

const SSOExpiryNotification = () => {
    const [ssoExpiryMinutes, setSsoExpiryMinutes] = useState<number | null>(null);
    const [overrideSSOModal, setOverrideSSOModal] = useState(false);

    const ssoMetadata = getSSOMetadata();

    const showSSOExpiryModal =
        ssoMetadata !== null &&
        ssoExpiryMinutes !== null &&
        !overrideSSOModal &&
        ssoExpiryMinutes <= 30;

    const onHideSSOModal = () => {
        setOverrideSSOModal(true);
    };

    useEffect(() => {
        let logoutInterval: number;
        let ssoWarningInterval: number;

        const ssoMetadata = getSSOMetadata();

        if (ssoMetadata && !isNullOrUndefined(ssoMetadata?.sessionExpiry)) {
            let checkDate = () => {};

            // Every minute check if we have to warn them of the expiry
            ssoWarningInterval = window.setInterval(checkDate, 60_000);

            checkDate = () => {
                const ssoExpiryMinutes = getMinutesFromDate(ssoMetadata.sessionExpiry);

                setSsoExpiryMinutes(ssoExpiryMinutes);

                if (ssoExpiryMinutes > 30) {
                    return;
                }

                clearInterval(ssoWarningInterval);
            };

            checkDate();

            // Every 5 seconds check if we should auto logout a user who has passed the max SSO session
            logoutInterval = window.setInterval(() => {
                const freshMetadata = getSSOMetadata();
                if (freshMetadata && Date.parse(freshMetadata.sessionExpiry) < Date.now()) {
                    signOutUser(true);
                    clearInterval(logoutInterval);
                }
            }, 5_000);
        }
        return () => {
            if (logoutInterval) {
                clearInterval(logoutInterval);
            }
            if (ssoWarningInterval) {
                clearInterval(ssoWarningInterval);
            }
        };
    }, []);

    const message = ssoMetadata?.sessionExpiry
        ? stringReplace(translations.SSO_EXPIRY_NOTIFICATION_expiration_time_message, {
              remainingMinutes: Math.floor(ssoExpiryMinutes ?? 0),
              expiryTime: new Date(ssoMetadata.sessionExpiry).toLocaleString(),
          })
        : '';

    const refreshSessionLink = !isNullOrWhitespace(ssoMetadata?.loginUri) && (
        <a href={ssoMetadata?.loginUri} target="_blank" rel="noreferrer">
            {' '}
            {translations.SSO_EXPIRY_NOTIFICATION_refresh_session_link_text}
        </a>
    );

    return (
        <ExDialog
            open={showSSOExpiryModal}
            dialogTitle="Your session is expiring soon"
            onCancel={onHideSSOModal}
        >
            {message}
            {refreshSessionLink}
        </ExDialog>
    );
};

export default SSOExpiryNotification;
